import { PermissionResources } from '@ravago/shared/page-data/models/features';

export async function hasPermissionToResource(resource: PermissionResources): Promise<boolean> {
  const response = await fetch(`/api/opa/resources/${resource}`, {
    method: 'HEAD'
  });
  return response.ok;
}
